import { Controller } from "@hotwired/stimulus"
import {
  formatDate,
  formatDuration,
  formatFriendlyDate,
  formatLongDate,
  formatShortDate,
  pageLocale,
} from '~/portal/i18n/dates'

const FORMATS = {
  friendly: (value, options) => formatFriendlyDate(value, options),
  duration: (value, options) => formatDuration(value, options),
  short_date: (value, options) => formatShortDate(value, options),
  date: (value, options) => formatDate(value, options),
  long_date: (value, options) => formatLongDate(value, options),
}

// A <time> the server rendered in English (PortalTimeHelper#portal_time), shown in the page's language. A Turbo
// morph puts the English back on the same element, so it is formatted again after each morph.
export default class extends Controller {
  static values = { format: String, timeZone: String, standalone: Boolean }

  connect() {
    this.render = this.render.bind(this)
    this.element.addEventListener('turbo:morph-element', this.render)
    this.render()
  }

  disconnect() {
    this.element.removeEventListener('turbo:morph-element', this.render)
  }

  render() {
    const format = FORMATS[this.formatValue]
    const value = this.element.getAttribute('datetime')
    if (!format || !value) return

    this.element.textContent = format(value, {
      locale: pageLocale(),
      timeZone: this.timeZoneValue || undefined,
      standalone: this.standaloneValue,
    })
  }
}
